export default __webpack_public_path__ + "a8291916a19c8de1f012fc401d985cc3.png";